<form #form="ngForm">
    <div class="app-grid centered">
        <mat-form-field class="columns-5 small-columns-11">
            <mat-label>{{ 'time-off-v3.policyName' | translate }}</mat-label>
            <input
                name="policyName"
                #policyName="ngModel"
                placeholder="{{ 'time-off-v3.egSickLeave' | translate }}"
                required
                [(ngModel)]="timeOffPolicy.name"
                matInput
                type="text"
            />
            <mat-error *ngIf="policyName.invalid">{{ policyName.errors | formErrors }}</mat-error>
        </mat-form-field>
        <ui-info class="columns-1 justify-start" [text]="policyFormToolTips.policyName"></ui-info>
    </div>
    <div class="app-grid">
        <mat-form-field class="columns-5 small-columns-11">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.timeOffType' | translate }}</mat-label>
            <mat-select
                name="timeOffTypeField"
                #timeOffTypeField="ngModel"
                placeholder="{{ 'time-off-v3.timeOffTypes' | translate }}"
                (ngModelChange)="setTimeOffType($event)"
                [ngModel]="timeOffTypeId ? timeOffTypeId : timeOffPolicy.timeOffTypeId"
                [disabled]="this.editForm"
                required
            >
                <mat-option *ngFor="let timeOffType of timeOffTypes" [value]="timeOffType.id">{{
                    timeOffType.name
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="timeOffTypeField.invalid">{{ timeOffTypeField.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid centered">
        <mat-form-field class="columns-5 small-columns-11">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.approvalFlow' | translate }}</mat-label>
            <mat-select
                name="approvalFlow"
                #approvalFlow="ngModel"
                [(ngModel)]="timeOffPolicy.timeOffApprovalFlowId"
                placeholder="{{ 'time-off-v3.approvalFlow' | translate }}"
                required
            >
                <mat-option *ngFor="let approvalFlow of timeOffApprovalFlows" [value]="approvalFlow.id">{{
                    approvalFlow.name
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="approvalFlow.invalid">{{ approvalFlow.errors | formErrors }}</mat-error>
        </mat-form-field>
        <ui-info class="columns-1 justify-start" [text]="policyFormToolTips.approvalFlow"></ui-info>
    </div>

    <div class="flex">
        <mat-radio-group
            name="accrualSetting"
            #accrualSetting="ngModel"
            required
            [ngModel]="timeOffPolicy.isUnlimited"
            (ngModelChange)="timeOffPolicy.isUnlimited = $event; resetTimeOffPolicyAccrualValues()"
            [value]="timeOffPolicy.isUnlimited"
        >
            <mat-label>{{ 'time-off-v3.accrualSetting' | translate }}</mat-label>
            <div class="accrual-settings">
                <mat-radio-button name="Accrues" [value]="false">{{
                    'time-off-v3.accrues' | translate
                }}</mat-radio-button>
                <mat-radio-button name="Unlimited" [value]="true">{{
                    'time-off-v3.unlimited' | translate
                }}</mat-radio-button>
                <mat-error *ngIf="accrualSetting.invalid">{{ accrualSetting.errors | formErrors }}</mat-error>
            </div>
        </mat-radio-group>
        <ui-info class="margin-left-1" [text]="policyFormToolTips.accrualSetting"></ui-info>
    </div>

    <ng-container *ngIf="!timeOffPolicy.isUnlimited && timeOffPolicy.isUnlimited !== undefined">
        <div class="app-grid centered accruals">
            <mat-form-field class="columns-5 medium-columns-6">
                <mat-label appRemoveAriaOwns>{{ 'time-off-v3.accrualFrequency' | translate }}</mat-label>
                <mat-select
                    name="accrualFrequency"
                    #accrualFrequency="ngModel"
                    placeholder="{{ 'time-off-v3.accrualFrequency' | translate }}"
                    [(ngModel)]="timeOffPolicy.accrualFrequency"
                    (selectionChange)="calculateDaysForPeriod(); accrualPreviews = []"
                    required
                >
                    <mat-option
                        *ngFor="let accrualFrequency of accrualFrequencies | keyvalue: undefined"
                        [value]="accrualFrequency.key"
                        >{{ 'time-off-v3.' + accrualFrequency.key | appTranslate }}</mat-option
                    >
                </mat-select>
                <mat-error *ngIf="accrualFrequency.invalid">{{ accrualFrequency.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-3 medium-columns-4">
                <mat-label>{{ this.unitOfTimeHeader | translate }}</mat-label>
                <input
                    type="number"
                    min="0"
                    name="daysAccruedPerPeriod"
                    #daysAccruedPerPeriod="ngModel"
                    placeholder="{{ 'time-off-v3.numberOfDays' | translate }}"
                    [ngModel]="days"
                    (ngModelChange)="days = $event; calculateDaysForPeriod()"
                    required
                    matInput
                />
                <mat-hint *ngIf="daysPerPeriod" align="end">{{
                    'time-off-v3.daysPerPeriodUnitOfTimePerPeriod'
                        | translate: { days: daysPerPeriod, unit: (unitOfTime | translate) }
                }}</mat-hint>
                <mat-error *ngIf="daysAccruedPerPeriod.invalid">{{
                    daysAccruedPerPeriod.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <ui-info class="columns-1 justify-start" [text]="policyFormToolTips.accrualFrequency"></ui-info>
        </div>

        <ng-container [ngSwitch]="timeOffPolicy.accrualFrequency">
            <app-weekly-fields
                *ngSwitchCase="'weekly'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            ></app-weekly-fields>

            <app-bi-weekly-fields
                *ngSwitchCase="'bi-weekly'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            ></app-bi-weekly-fields>

            <app-semi-monthly-fields
                *ngSwitchCase="'semi-monthly'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            >
            </app-semi-monthly-fields>

            <app-monthly-fields
                *ngSwitchCase="'monthly'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            ></app-monthly-fields>

            <app-quarterly-fields
                *ngSwitchCase="'quarterly'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            ></app-quarterly-fields>

            <app-annual-fields
                *ngSwitchCase="'annually'"
                [timeOffPolicy]="timeOffPolicy"
                (requestPreviewParams)="getAccrualPreview($event)"
            >
            </app-annual-fields>
        </ng-container>

        <div *ngIf="timeOffPolicy.accrualFrequency && timeOffPolicy.accrualFrequency !== 'daily'" class="app-grid">
            <mat-form-field class="columns-5">
                <mat-label appRemoveAriaOwns>{{ 'time-off-v3.accrualsHappenOn' | translate }}</mat-label>
                <mat-select
                    name="accrualTiming"
                    #accrualTiming
                    #accrualTimingModel="ngModel"
                    placeholder="{{ 'time-off-v3.accrualTiming' | translate }}"
                    [(ngModel)]="timeOffPolicy.accrualTiming"
                    (selectionChange)="getAccrualPreview(timeOffPolicy.accrualFrequency)"
                    required
                >
                    <mat-option [value]="'first-day'">{{ 'time-off-v3.firstDayOfPeriod' | translate }}</mat-option>
                    <mat-option [value]="'last-day'">{{ 'time-off-v3.lastDayOfPeriod' | translate }}</mat-option>
                    <mat-option [value]="'next-first-day'">{{
                        'time-off-v3.firstDayOfNextPeriod' | translate
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="accrualTimingModel.invalid">{{ accrualTimingModel.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <!--Preview-->
        <div *ngIf="accrualPreviews.length > 0" class="app-grid preview">
            <h4>{{ 'time-off-v3.accrualSchedulePreview' | translate }}</h4>
            <table class="columns-9 table ui">
                <thead>
                    <tr>
                        <th>{{ 'time-off-v3.firstDayOfPeriod' | translate }}</th>
                        <th>{{ 'time-off-v3.lastDayOfPeriod' | translate }}</th>
                        <th>{{ 'time-off-v3.accrualHappensOn' | translate }}</th>
                        <th>{{ 'time-off-v3.accrualAmount' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let accrualPreview of accrualPreviews">
                        <td>{{ accrualPreview.attributes.startDate | appDate: 'fullDate' }}</td>
                        <td>{{ accrualPreview.attributes.endDate | appDate: 'fullDate' }}</td>
                        <td>
                            {{
                                getAccrualHappenOnDate(
                                    accrualPreview.attributes.startDate,
                                    accrualPreview.attributes.endDate
                                ) | appDate: 'fullDate'
                            }}
                        </td>
                        <td>{{ daysPerPeriod }} {{ unitOfTime | translate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</form>
